import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import Select from 'react-select';

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import ExportCSV from "../../../utils/ExportCSV/ExportCSV";
import { statisticAdminContext } from "../../../context/Admin/StatisticAdminContext/StatisticAdminContext";
import { DateInput } from "react-hichestan-datetimepicker";
import {
  convertDataToCSV,
  dialogContainerStyle,
  numberSeparate,
} from "../../../utils";

const StatisticAdmin = () => {
  const {
    statistics,
    mobile_verified,
    setMobile_verified,
    dateType,
    setDateType,
    isNot_in,
    setIsNot_in,
    table, // Consider renaming this context state to 'selectedService' later
    setTable,
    fromDate,
    setFromDate,
    limit,
    setLimit,
    toDate,
    setToDate,
    services,
    order_status,
    setOrder_status,
    employers,
    employer,
    setEmployer,
    handleGetStatistics,
    handleGetServices,
    handleGetEmployers,
    managedCities,
    selectedCities,
    setSelectedCities,
  } = useContext(statisticAdminContext);

  useEffect(() => {
    handleGetServices();
    handleGetEmployers();
  }, []);

  // --- React-Select Options Definitions ---
  const employerOptions = [
    { value: "", label: "همه مشتریان (عادی و سازمانی)" },
    { value: "normal_only", label: "فقط مشتریان عادی (بدون سازمان)" },
    ...(employers?.map((e) => ({ value: e.id, label: `سازمان: ${e.name}` })) || []),
  ];

  const serviceOptions = services?.map((s, index) => ({
    value: index,
    label: s.name,
  })) || [];

  const orderStatusOptions = [
    { value: "false", label: "همه وضعیت‌ها" },
    { value: "true", label: "فقط سفارشات موفق" },
  ];

  const copyTable = () => {
    const elTable = document.querySelector("#StatisticsTable");
    let range, sel;
    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      sel.removeAllRanges();
      try {
        range.selectNodeContents(elTable);
        sel.addRange(range);
      } catch (e) {
        range.selectNode(elTable);
        sel.addRange(range);
      }
      document.execCommand("copy");
    }
    sel.removeAllRanges();
  };

  // Helper to ensure we send explicit empty strings or real nulls to backend
  const handleEmployerChange = (e) => {
    const val = e.target.value;
    if (val === "") setEmployer("");
    else if (val === "normal_only") setEmployer(null); // Will be sent as null
    else setEmployer(val);
  };

  return (
    <>
      <SiteTitle title="گزارش‌گیری و آمار کاربران" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "آمارگیری", type: "a" },
        ]}
        title="گزارش‌گیری کاربران"
      />

      <CardLayout>
        <form onSubmit={handleGetStatistics} autoComplete="off">

          {/* --- SECTION 1: TIME LIMITS --- */}
          <div className="mb-4">
            <h5 className="text-primary border-bottom pb-2 mb-3">۱. فیلتر زمان ثبت‌نام کاربر</h5>
            <p className="text-muted small mb-3">مشخص کنید کاربران در چه بازه زمانی در کارباما ثبت‌نام کرده‌اند.</p>

            <div className="d-flex flex-wrap gap-4 mb-3">
              <div className="custom-control custom-radio ml-4 mb-2">
                <input
                  type="radio"
                  id="dateType0"
                  name="dateType"
                  className="custom-control-input"
                  checked={dateType === 0}
                  onChange={() => setDateType(0)}
                />
                <label className="custom-control-label fw-bold" htmlFor="dateType0">همه زمان‌ها</label>
              </div>
              <div className="custom-control custom-radio ml-4 mb-2">
                <input
                  type="radio"
                  id="dateType1"
                  name="dateType"
                  className="custom-control-input"
                  checked={dateType === 1}
                  onChange={() => setDateType(1)}
                />
                <label className="custom-control-label fw-bold" htmlFor="dateType1">از تاریخ مشخص</label>
              </div>
              <div className="custom-control custom-radio ml-4 mb-2">
                <input
                  type="radio"
                  id="dateType2"
                  name="dateType"
                  className="custom-control-input"
                  checked={dateType === 2}
                  onChange={() => setDateType(2)}
                />
                <label className="custom-control-label fw-bold" htmlFor="dateType2">بازه تاریخی (از - تا)</label>
              </div>
              <div className="custom-control custom-radio ml-4 mb-2">
                <input
                  type="radio"
                  id="dateType3"
                  name="dateType"
                  className="custom-control-input"
                  checked={dateType === 3}
                  onChange={() => setDateType(3)}
                />
                <label className="custom-control-label fw-bold" htmlFor="dateType3">روزهای اخیر</label>
              </div>
            </div>

            <div className="row">
              {dateType === 1 && (
                <div className="col-12 col-md-4">
                  <DateInput
                    id="fromDate"
                    value={fromDate}
                    className="form-control"
                    name="fromDate"
                    onChange={(e) => setFromDate(e.target.value)}
                    autoOk="false"
                    placeholder="انتخاب تاریخ مبدا"
                    dialogContainerStyle={dialogContainerStyle}
                  />
                </div>
              )}
              {dateType === 2 && (
                <>
                  <div className="col-12 col-md-4 mb-2 mb-md-0">
                    <DateInput
                      id="fromDate"
                      value={fromDate}
                      className="form-control"
                      name="fromDate"
                      onChange={(e) => setFromDate(e.target.value)}
                      autoOk="false"
                      placeholder="از تاریخ"
                      dialogContainerStyle={dialogContainerStyle}
                    />
                  </div>
                  <div className="col-12 col-md-4">
                    <DateInput
                      id="toDate"
                      value={toDate}
                      className="form-control"
                      name="toDate"
                      onChange={(e) => setToDate(e.target.value)}
                      autoOk="false"
                      placeholder="تا تاریخ"
                      dialogContainerStyle={dialogContainerStyle}
                    />
                  </div>
                </>
              )}
              {dateType === 3 && (
                <div className="col-12 col-md-4">
                  <div className="input-group">
                    <input
                      type="number"
                      className="form-control"
                      value={limit}
                      min="0"
                      placeholder="مثلا: 7"
                      onChange={(e) => setLimit(Math.max(0, parseInt(e.target.value || 0)))}
                    />
                    <span className="input-group-text">روز گذشته</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* --- SECTION 2: DEMOGRAPHICS --- */}
          <div className="mb-4">
            <h5 className="text-primary border-bottom pb-2 mb-3">۲. فیلتر مشخصات کاربر</h5>

            <div className="row align-items-start">
              <div className="col-md-6 mb-3">
                <label className="fw-bold mb-1">نوع مشتری (سازمانی / عادی)</label>
                <Select
                  options={employerOptions}
                  value={employerOptions.find(opt => opt.value === (employer === null ? "normal_only" : (employer || "")))}
                  onChange={(selected) => handleEmployerChange({ target: { value: selected.value } })}
                  isRtl={true}
                  placeholder="انتخاب نوع مشتری..."
                  className="font-sans text-sm"
                  classNamePrefix="select"
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="fw-bold mb-1">شهرها</label>
                <Select
                  id="cities"
                  name="cities"
                  options={managedCities}
                  value={selectedCities}
                  onChange={setSelectedCities}
                  isMulti
                  isRtl={true}
                  placeholder="همه شهرها (یا انتخاب کنید...)"
                  noOptionsMessage={() => "شهری یافت نشد"}
                  className="basic-multi-select font-sans text-sm"
                  classNamePrefix="select"
                />
              </div>

              <div className="col-12 mt-2">
                <label className="fw-bold mb-2">وضعیت تایید شماره موبایل:</label>
                <div className="d-flex gap-4">
                  <div className="custom-control custom-radio ml-4 mb-2">
                    <input
                      type="radio"
                      id="mobile_verified0"
                      name="mobile_verified"
                      className="custom-control-input"
                      checked={mobile_verified === "0"}
                      onChange={() => setMobile_verified("0")}
                    />
                    <label className="custom-control-label" htmlFor="mobile_verified0">همه (مهم نیست)</label>
                  </div>
                  <div className="custom-control custom-radio ml-4 mb-2">
                    <input
                      type="radio"
                      id="mobile_verifiedTrue"
                      name="mobile_verified"
                      className="custom-control-input"
                      checked={mobile_verified === "true"}
                      onChange={() => setMobile_verified("true")}
                    />
                    <label className="custom-control-label" htmlFor="mobile_verifiedTrue">فقط تایید شده‌ها</label>
                  </div>
                  <div className="custom-control custom-radio ml-4 mb-2">
                    <input
                      type="radio"
                      id="mobile_verifiedFalse"
                      name="mobile_verified"
                      className="custom-control-input"
                      checked={mobile_verified === "false"}
                      onChange={() => setMobile_verified("false")}
                    />
                    <label className="custom-control-label" htmlFor="mobile_verifiedFalse">فقط تایید نشده‌ها</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* --- SECTION 3: ORDER HISTORY --- */}
          <div className="mb-4">
            <h5 className="text-primary border-bottom pb-2 mb-3">۳. فیلتر سابقه سفارشات</h5>
            <p className="text-muted small mb-3">کاربران را بر اساس سرویس‌هایی که دریافت کرده‌اند (یا نکرده‌اند) فیلتر کنید.</p>

            <div className="row align-items-center bg-light p-3 rounded mx-0">
              <div className="col-md-5 mb-3 mb-md-0">
                <label className="fw-bold mb-1">نوع سرویس</label>
                <Select
                  options={serviceOptions}
                  value={serviceOptions.find(opt => opt.value === table) || null}
                  onChange={(selected) => setTable(selected.value)}
                  isRtl={true}
                  placeholder="انتخاب سرویس..."
                  className="font-sans text-sm"
                  classNamePrefix="select"
                />
              </div>

              <div className="col-md-3 mb-3 mb-md-0">
                <label className="fw-bold mb-1">وضعیت سفارش</label>
                <Select
                  options={orderStatusOptions}
                  value={orderStatusOptions.find(opt => opt.value === order_status.toString())}
                  onChange={(selected) => setOrder_status(selected.value === "true")}
                  isRtl={true}
                  isSearchable={false}
                  className="font-sans text-sm"
                  classNamePrefix="select"
                />
              </div>

              <div className="col-md-4 mt-md-4">
                <div className="custom-control custom-switch border-start ps-4">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="isNot_in"
                    checked={isNot_in === "true"} // Ensures boolean evaluation
                    onChange={(e) => setIsNot_in(e.target.checked ? "true" : "")} // Sends explicit string for Python
                  />
                  <label className="custom-control-label fw-bold text-danger" htmlFor="isNot_in">
                    معکوس کردن فیلتر
                  </label>
                  <small className="d-block text-muted mt-1">
                    {isNot_in === "true"
                      ? "نمایش کاربرانی که این سرویس را هرگز دریافت نکرده‌اند."
                      : "نمایش کاربرانی که این سرویس را حداقل یکبار دریافت کرده‌اند."}
                  </small>
                </div>
              </div>
            </div>
          </div>

          {/* --- SUBMIT & EXPORT --- */}
          <div className="d-flex justify-content-between align-items-center mt-5">
            <button type="submit" className="btn btn-primary px-5 fw-bold shadow-sm">
              <i className="fas fa-search ml-2" /> دریافت گزارش
            </button>

            {!isEmpty(statistics) && (
              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={copyTable}
                >
                  <i className="fas fa-copy me-2" /> کپی جدول
                </button>
                <ExportCSV
                  csvData={() => convertDataToCSV(statistics, "statistics")}
                />
              </div>
            )}
          </div>
        </form>

        <hr className="my-5" />

        {/* --- DATA TABLE --- */}
        {isEmpty(statistics) ? (
          <EmptyData text="کاربری با این مشخصات یافت نشد." />
        ) : (
          <Table responsive hover borderless striped id="StatisticsTable" className="shadow-sm border">
            <thead className="table-dark">
              <tr>
                <th className="rounded-start">#</th>
                <th>نام</th>
                <th>نام خانوادگی</th>
                <th>شماره موبایل</th>
                <th className="rounded-end text-center">تعداد کل سفارشات</th>
              </tr>
            </thead>
            <tbody>
              {statistics.map((_item, index) => (
                <tr key={index}>
                  <td className="fw-bold text-muted">{index + 1}</td>
                  <td>{_item.user.first_name || "-"}</td>
                  <td>{_item.user.last_name || "-"}</td>
                  <td dir="ltr" className="text-end">{_item.user.mobile}</td>
                  <td className="text-center fw-bold text-primary">
                    {numberSeparate(_item.user.order_count?.all || 0)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </CardLayout>
    </>
  );
};

export default StatisticAdmin;